import { Carousel, CarouselContent, CarouselControls, CarouselItem } from '~/components/ui/carousel';
import { cn } from '~/styles/extended-theme.ts';
import { type PropsWithClassName } from '~/utils/props-with-classname';

interface Props {
  urls: string[];
}

export function GymPhotos({ urls: baseUrls, className }: PropsWithClassName<Props>) {
  const urls = baseUrls.length === 0 ? ['/img/fp_placeholder_gymdetail.png'] : baseUrls;

  return (
    <Carousel className={cn('aspect-video overflow-hidden rounded-2xl', className)}>
      <CarouselContent>
        {urls.map((url) => (
          <CarouselItem key={url}>
            <div className="aspect-video">
              <img src={url} alt="" className="h-full w-full object-cover" />
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>

      <CarouselControls />
    </Carousel>
  );
}
